import axios from "axios";
import {
	currentNotificationAction,
	lssBlockNotificationDataAction,
	setTokenAction,
} from "../redux/actions/actions";

async function deleteSelectedCookies() {
	const cookies = document.cookie.split(";");
	const { data } = await axios("/config.json?_=" + new Date().getTime());
	const coolieConfig = data.cookies;
	const cookieNamesToDelete = Object.values(coolieConfig);

	for (let i = 0; i < cookies.length; i++) {
		const cookie = cookies[i].trim();
		const eqPos = cookie.indexOf("=");
		console.log("eqPos", eqPos);
		const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
		console.log("name", name);
		if (cookieNamesToDelete.includes(name)) {
			const domainParts = window.location.hostname.split(".");
			for (let j = 0; j < domainParts.length; j++) {
				const domain = domainParts.slice(-1 * (j + 1)).join(".");
				document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=${domain}`;
				document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.${domain}`;
			}
			document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
		}
	}
}

export default function signOut(dispatch) {
	console.log("signOut");

	localStorage.removeItem("personalStudioAccessToken");
	localStorage.removeItem("personalStudioRefreshToken");
	localStorage.removeItem("mentor_chat_token");
	localStorage.removeItem("mentor_chat_title");
	localStorage.removeItem("user_type");
	sessionStorage.removeItem("personalStudioAccessToken");
	sessionStorage.removeItem("personalStudioRefreshToken");
	dispatch(setTokenAction({ access_token: "", refresh_token: "" }));
	dispatch(currentNotificationAction(null));
	dispatch(lssBlockNotificationDataAction(null));
	dispatch(currentNotificationAction(null));
	deleteSelectedCookies();
}
